export const DEFAULT = {
	Pragma: 'no-cache',
	'Content-Type': 'application/json-patch+json',
}
